export default __webpack_public_path__ + "static/media/36I-114287_-20986_0.1fb5a22c.jpg";